import script from "./ConfirmDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConfirmDialog.vue?vue&type=script&lang=ts&setup=true"

import "./ConfirmDialog.vue?vue&type=style&index=0&id=0745de54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0745de54"]])

export default __exports__